import { Outlet } from 'react-router';
import { TenantLink } from '~/lib/navigation';

/**
 * Sandbox Dashboard Layout
 * Demonstrates nested layouts with sidebar navigation
 */
export default function SandboxDashboardLayout() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <TenantLink to="/sandbox" preserveParams={false} className="text-sm text-muted-foreground hover:text-foreground">
          ← Back to sandbox home
        </TenantLink>
      </div>

      <div className="flex gap-8">
        {/* Sidebar navigation */}
        <aside className="w-48 flex-shrink-0">
          <nav className="space-y-2">
            <TenantLink
              to="/sandbox/dashboard"
              preserveParams={false}
              className="block px-4 py-2 rounded-md hover:bg-accent"
            >
              Overview
            </TenantLink>
            <TenantLink
              to="/sandbox/dashboard/items"
              preserveParams={false}
              className="block px-4 py-2 rounded-md hover:bg-accent"
            >
              Items
            </TenantLink>
          </nav>
        </aside>

        {/* Main content */}
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
